import React, { forwardRef, useImperativeHandle  } from 'react';

const ThermalBillPrint = forwardRef((props, ref) => {
    const { billingData } = props;
    
    // Add imperative handle to ensure refs work correctly
    useImperativeHandle(ref, () => ({
        // You can add methods here if needed
    }));

    if (!billingData) {
        return <div ref={ref}>No billing data available.</div>;
    }

    // Destructure billing data
    const {
        customer_name,
        customer_mobile,
        products,
        taxable_amount,
        discount,
        discount_type,
        total_amount,
        round_off
    } = billingData || {};

    return (
        <div ref={ref} style={{ width: '58mm', padding: '2mm', fontSize: '8px', fontFamily: 'monospace', margin: '0 auto' }}>
            {/* Business Header */}
            <div style={{ textAlign: 'center', marginBottom: '2mm' }}>
                <h3 style={{ margin: 0, fontSize: '10px' }}>Your Business Name</h3>
                <p style={{ margin: 0, fontSize: '8px' }}>Business Address Line 1</p>
                <p style={{ margin: 0, fontSize: '8px' }}>Business Address Line 2</p>
                <p style={{ margin: 0, fontSize: '8px' }}>Contact: XXXXXXXXXX</p>
            </div>

            {/* Bill Details */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                borderBottom: '1px dashed #000',
                paddingBottom: '1mm',
                fontSize: '8px'
            }}>
                <div>
                    <p style={{ margin: 0 }}>Bill No: {Math.floor(Math.random() * 10000)}</p>
                    <p style={{ margin: 0 }}>Date: {new Date().toLocaleString()}</p>
                </div>
                {customer_name && (
                    <div style={{ textAlign: 'right' }}>
                        <p style={{ margin: 0 }}>{customer_name}</p>
                        <p style={{ margin: 0 }}>{customer_mobile}</p>
                    </div>
                )}
            </div>

            {/* Product Details */}
            <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '2mm',
                fontSize: '8px'
            }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid #000', padding: '1mm', textAlign: 'left' }}>Item</th>
                        <th style={{ border: '1px solid #000', padding: '1mm', textAlign: 'right' }}>Qty</th>
                        <th style={{ border: '1px solid #000', padding: '1mm', textAlign: 'right' }}>Rate</th>
                        <th style={{ border: '1px solid #000', padding: '1mm', textAlign: 'right' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {products?.map((product, index) => (
                        <tr key={index}>
                            <td style={{ border: '1px solid #000', padding: '1mm', textAlign: 'left' }}>
                                {product.product_id}
                            </td>
                            <td style={{ border: '1px solid #000', padding: '1mm', textAlign: 'right' }}>
                                {product.quantity}
                            </td>
                            <td style={{ border: '1px solid #000', padding: '1mm', textAlign: 'right' }}>
                                {product.rate}
                            </td>
                            <td style={{ border: '1px solid #000', padding: '1mm', textAlign: 'right' }}>
                                {product.amount}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Summary */}
            <div style={{
                marginTop: '2mm',
                borderTop: '1px dashed #000',
                paddingTop: '1mm',
                fontSize: '8px'
            }}>
                <p style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                    <span>Taxable Amount:</span>
                    <span>{taxable_amount?.toFixed(2)}</span>
                </p>
                <p style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                    <span>Discount ({discount_type}):</span>
                    <span>{discount_type === 'percentage' ? `${discount}%` : `₹${discount?.toFixed(2)}`}</span>
                </p>
                <p style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                    <span>Round Off:</span>
                    <span>{round_off?.toFixed(2)}</span>
                </p>
                <p style={{
                    margin: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontWeight: 'bold',
                    borderTop: '1px solid #000',
                    paddingTop: '1mm'
                }}>
                    <span>Total Amount:</span>
                    <span>₹{total_amount?.toFixed(2)}</span>
                </p>
            </div>

            {/* Footer */}
            <div style={{
                textAlign: 'center',
                marginTop: '2mm',
                fontSize: '8px',
                borderTop: '1px dashed #000',
                paddingTop: '1mm'
            }}>
                <p style={{ margin: 0 }}>Thank You! Visit Again</p>
            </div>
        </div>
    );
});

export default ThermalBillPrint;


